import {
  GET_CATEGORY_ORGANIZATION,
  CREATE_CATEGORY_ORGANIZATION,
  DELETE_CATEGORY_ORGANIZATION,
  UPDATE_CATEGORY_ORGANIZATION,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const CategoryOrganizationApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CategoryOrganizationApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const CategoryOrganization = () => ({
  type: GET_CATEGORY_ORGANIZATION,
});

export const CreateCategoryOrganization = (data) => ({
  type: CREATE_CATEGORY_ORGANIZATION,
  payload: { data },
});

export const UpdateCategoryOrganization = (data) => ({
  type: UPDATE_CATEGORY_ORGANIZATION,
  payload: { data },
});

export const DeleteCategoryOrganization = (id) => ({
  type: DELETE_CATEGORY_ORGANIZATION,
  payload: { id },
});

